import { render } from "./IndexDefault.vue?vue&type=template&id=baede480"
import script from "./IndexDefault.vue?vue&type=script&lang=js"
export * from "./IndexDefault.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__